<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <nav>
                    <div class="nav nav-tabs" role="tablist">
                        <button @click="MostrarF(false)" class="nav-link active" id="historial-tab" data-bs-toggle="tab" data-bs-target="#historial" type="button" role="tab" aria-controls="historial" aria-selected="true">Historial</button>
                        <button @click="MostrarF(true)" class="nav-link" id="estatus-tab" data-bs-toggle="tab" data-bs-target="#estatus" type="button" role="tab" aria-controls="estatus" aria-selected="false">Cambiar Estatus</button>
                    </div>
                </nav>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="historial" role="tabpanel" aria-labelledby="historial-tab">
                        <div class="row">
                            <div class="col-lg-12">
                                <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                                    <template slot="header">
                                        <th :class="StyleTh+' text-center'">Realizó</th>
                                            <th :class="StyleTh">Fecha Inicio</th>
                                            <th :class="StyleTh">Estatus Anterior</th>
                                            <th :class="StyleTh">Estatus Modificado</th>
                                            <th :class="StyleTh">Observaciones</th>
                                    </template>
                                    <template slot="body">
                                        <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                                            <td class="text-center"><h6 v-if="lista.usuario" :class="StylePr">{{lista.usuario.NombreCompleto}}</h6></td>
                                            <td><p :class="StyleTd">{{$getCleanDate(lista.FechaInicio,true)}}</p></td>
                                            <td><p :class="StyleTd">{{lista.EstatusAnterior}}</p></td>
                                            <td><p :class="StyleTd">{{lista.Estatus}}</p></td>
                                            <td><p :class="StyleTd">{{lista.Observaciones}}</p></td>
                                        </tr>
                                    </template>
                                </CList>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="estatus" role="tabpanel" aria-labelledby="estatus-tab">
                        <div class="row">
                            <div class="col-lg-12">
                                <form id="FormEstatus" role="form" method="post" autocomplete="off" onSubmit="return false">
                                    <div class="form-group row">
                                        <div class="col-lg-6">
                                            <label for="">Estatus Actual del Pedido</label>
                                            <p>{{ObjEstatusxPedidos.EstatusAnterior}}</p>
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="">Cambiar A:</label>
                                            <select @change="CambiarEstatus()" class="form-control form-select" id="" v-model="ObjEstatusxPedidos.IdEstatusProceso">
                                                <option value="">--Seleccionar--</option>
                                                <option v-for="(item,index) in ListEstatus" :key="index" :value="item.IdEstatusProceso">{{ item.Nombre }}</option>
                                            </select>
                                            <CValidation v-if="this.errorvalidacion.IdEstatusProceso" :Mensaje="'*'+errorvalidacion.IdEstatusProceso[0]"/>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-lg-12">
                                            <label for="">Observaciones</label>
                                            <textarea v-model="ObjEstatusxPedidos.Observaciones" name="" class="form-control" rows="4" placeholder="Observaciones" id=""></textarea>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default{
    name: 'FormEstatusFisico',
    props: ['poBtnSave'],
    components:{
    },
    data(){
        return{
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigList:{
                Title: 'Historial',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: this.poBtnSave.EmitSeccion,
                BtnReturnShow: false,
                ShowTitleFirst: false,
                TitleFirst: '',
                BtnNewShow: false,
                ShowSearch: false,
                ShowFooter: false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ListaArrayRows:[],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Emit:this.poBtnSave.EmitSeccion,
            segurity:{},
            ObjEstatusxPedidos:{
                IdPedido: 0,
                IdPedidoFisico: 0,
                IdGarantia: 0,
                IdUsuario: 0,
                FechaInicio: '',
                FechaEstimadaCambio: '',
                FechaRealCambio:'',
                Estatus: '',
                EstatusAnterior: '',
                Observaciones: '',
                IdEstatusProceso: ""
            },
            ListEstatus:[],
            errorvalidacion:[]
        }
    },
    methods:{
        async Guardar(){
            this.poBtnSave.DisableBtn = true;
            await this.$http.post('estatusxpedidoGt',this.ObjEstatusxPedidos).then((res)=>{
                this.EjecutaConExito(res);
            }).catch((err)=>{
                this.EjecutaConError(err);
            })
        },
        EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionGarantia');
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        async Lista(){
            await this.$http.get('estatusxpedidoGt',{
                params: {
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdGarantia: this.ObjEstatusxPedidos.IdGarantia
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        async GetListaEstatus(){
            await this.$http.get('catasestatussimple').then((res)=>{
                this.ListEstatus = res.data.data;
                let Index=this.ListEstatus.findIndex((element)=>element.Nombre==this.ObjEstatusxPedidos.EstatusAnterior);
                if (Index!=-1) {
                    this.ListEstatus.splice(Index,1);   
                }
            });
        },  
        MostrarF(val){
            this.bus.$emit('MostrarFooterGt',val);
        },
        Limpiar(){
            this.ObjEstatusxPedidos={
                IdPedido:0,
                IdPedidoFisico:0,
                IdGarantia:0,
                IdUsuario:0,
                FechaInicio:'',
                FechaEstimadaCambio:'',
                FechaRealCambio:'',
                Estatus:'',
                EstatusAnterior:'',
                Observaciones:'',
                IdEstatusProceso:""
            }
        },
        CambiarEstatus(){
            let index=this.ListEstatus.findIndex((element)=>element.IdEstatusProceso==this.ObjEstatusxPedidos.IdEstatusProceso);
            if (index!=-1) {
                this.ObjEstatusxPedidos.Estatus=this.ListEstatus[index].Nombre;   
            }
            else{
                this.ObjEstatusxPedidos.Estatus="";
            }
        }
    },
    created(){
        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>{
            this.Limpiar();
            console.log(obj);
            this.ObjEstatusxPedidos.IdGarantia = obj.IdGarantiaS;
            this.ObjEstatusxPedidos.EstatusAnterior = obj.EstatusPedido;
            this.GetListaEstatus();
            this.Lista();
            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
        })
    }
}
</script>